import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment'; 

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private http: HttpClient,
  ) { }

  // Login
  async authUser(credentials) {
    return this.http.post(environment.apiBaseUrl + '/auth/login', credentials);
  }

  isLoggedIn(): boolean {
    return !!localStorage.getItem('email');
  }
  
}
